<!--
 * @FilePath: Notice.vue
 * @Author: chenwei
 * @Date: 2021-11-09 15:12:05
 * @LastEditors: chenwei
 * @LastEditTime: 2022-07-14 14:19:14
 * Copyright: 2022 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion: 
-->
<template>
    <vueSeamless
        :data="listData"
        :class-option="classOption"
        class="warp"
    >
        <ul class="item">
        <li v-for="(item, index) in listData" :key="index">
            <span class="title" v-text="item.noticeContent"></span>
        </li>
        </ul>
    </vueSeamless>
</template>

<script>
import vueSeamless from 'vue-seamless-scroll'
import {
    getNoticeList,
} from "@/api/notice/index"
export default {
    data(){
        return {
            listData: []
        }
    },
    components:{
        vueSeamless
    },
    created(){
        this.getList()
    },
    destroyed(){
    },
    computed:{
        classOption () {
            return {
                singleHeight: 20,
                waitTime: 2500,
            }
        }
    },
    methods: {
        async getList(){
            let that = this
            let res = await getNoticeList(that.page)
            that.listData = res.data.list
        },
    }
}
</script>

<style lang="scss" scoped>
.warp {
  height: 20px;
  overflow: hidden;
  margin-top: 0;
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    li,
    a {
      height: 20px;
      
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 15px;
      .title{
            line-height: 20px;
            height: 20px;
            vertical-align: middle;
            
            max-width: 1200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
      }
    }
  }
}
</style>